/**
 * Contrato interno de reconhecimento. Ele deliberadamente não conhece React,
 * telas ou envio de mensagens: um `listeningEnd` é o fim de uma sessão do
 * provider, não o fim de um turno de conversa.
 *
 * Implementações atuais:
 * - WebSpeechAdapter (site/PWA)
 * - NativeSpeechAdapter (Capacitor Android)
 *
 * Uma implementação futura de STT remoto pode respeitar o mesmo contrato sem
 * mudar Home, Workspace ou Visual Call.
 */
export const ATHENA_STT_EVENTS = Object.freeze({
  LISTENING_START: 'listeningStart',
  SPEECH_DETECTED: 'speechDetected',
  SPEECH_ENDED: 'speechEnded',
  PARTIAL_TRANSCRIPT: 'partialTranscript',
  FINAL_TRANSCRIPT: 'finalTranscript',
  LISTENING_END: 'listeningEnd',
  ERROR: 'error',
});

export class SpeechToTextProvider {
  start() { throw new Error('SpeechToTextProvider.start must be implemented'); }
  stop() { throw new Error('SpeechToTextProvider.stop must be implemented'); }
  cancel() { throw new Error('SpeechToTextProvider.cancel must be implemented'); }
  getCapabilities() { return { microphone: false, stt: false }; }
}
